import { Trans } from '@lingui/macro'
import { FormControlLabel } from '@mui/material'
import { useDispatch } from 'react-redux'
import { FormSaveButton } from './FormSaveButton'
import DebouncedTextField from '../../common/DebouncedTextField'
import Checkbox from 'app/views/common-components/CustomCheckbox'

export const FormEditorSaveButton = ({
  editMode,
  depth,
  typeProps = {},
  injectable,
  ...props
}) => {
  const {
    showAllErrors,
    showSectionErrors,
    errorListTitle
  } = typeProps
  const dispatch = useDispatch()
  if (!editMode) {
    return <FormSaveButton {...props} typeProps={typeProps} />
  }

  return (
    <div>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(showAllErrors)}
              onChange={e => {
                const toSet = { ...typeProps }
                toSet.showAllErrors = e.target.checked
                delete toSet.showSectionErrors
                dispatch({
                  type: 'FIELD',
                  injectable,
                  depth: depth.split('.'),
                  fieldName: 'typeProps',
                  fieldValue: { ...toSet }
                })
              }}
            />
          }
          label={<Trans>Show all errors?</Trans>}
        />
      </div>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(showSectionErrors)}
              onChange={e => {
                const toSet = { ...typeProps }
                toSet.showSectionErrors = e.target.checked
                delete toSet.showAllErrors
                dispatch({
                  type: 'FIELD',
                  injectable,
                  depth: depth.split('.'),
                  fieldName: 'typeProps',
                  fieldValue: { ...toSet }
                })
              }}
            />
          }
          label={<Trans>Show errors from current section?</Trans>}
        />
        <DebouncedTextField
          value={errorListTitle || ''}
          style={{ marginTop: 15, marginBottom: 5 }}
          fullWidth
          label={<Trans>FORM_EDITOR_FIELD_ERRORS_LIST_HEADER</Trans>}
          variant='outlined'
          multiline
          onChange={(e) => {
            const toSet = { ...typeProps }
            toSet.errorListTitle = e.target.value
            if (!e.target.value) {
              delete toSet.errorListTitle
            }
            dispatch({
              type: 'FIELD',
              injectable,
              depth: depth.split('.'),
              fieldName: 'typeProps',
              fieldValue: { ...toSet }
            })
          }}
        />
      </div>
    </div>
  )
}
